module.exports = __webpack_public_path__ + "static/media/Figtree-Regular.fde4a0ff.ttf";